import { selectCurrentFormat } from '../utils/formatSelector';

const MAX_OPEN_FILE_SIZE = 30; //30MB
const POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_PO = 'https://www.polarisoffice.com/download';
const POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_MAC =
  'https://apps.apple.com/app/polaris-office-hwp-pdf/id1098211970';
const POLARIS_OFFICE_CLIENT_DOWNLOAD_IOS =
  'https://apps.apple.com/app/polaris-office-pdf-docs/id698070860';
const POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_ANDROID =
  'https://play.google.com/store/apps/details?id=com.infraware.office.link';

const USE_REACT_ROUTER = process.env.REACT_APP_USE_REACT_ROUTER === 'true' || false;

const URLS = {
  EDITOR: {
    HWP: 'https://hwp.polarisoffice.com/',
    SHEET: 'https://sheet.polarisoffice.com/',
    SLIDE: 'https://slide.polarisoffice.com/',
    WORD: 'https://word.polarisoffice.com/',

    EDU: 'https://edu.polarisoffice.com/',

    // IMPORTANT!! ONLY Dev
    _HWP_DEV: 'https://vf-webeditor.polarisoffice.com/',
    _SHEET_DEV: 'https://vf-websheet.polarisoffice.com/',
    _SLIDE_DEV: 'https://vf-webslide.polarisoffice.com/',
    _WORD_DEV: 'https://vf-webword.polarisoffice.com/',

    _EDU_DEV: 'https://vf-edu.polarisoffice.com/'
  },
  NOTION: {
    HOME: 'https://www.notion.so/6393dc0bbbe141d787e15b696838044c#8790698ab8d64c2798c2c3431a6b2d61',
    MAKE_DIRECTLINK: 'https://www.notion.so/4a2b763b394348f784034af3c0a973ed',
    USE_FONT_CONTENTS: 'https://www.notion.so/94b37da710ed4a1b8627c7e92112b66b',
    USE_FONT_CONTENTS_ENG:
      'https://www.notion.so/Font-List-for-English-3f6271ab484345cab7f7d80107d2da8e',
    SHORTCUT: {
      HWP: 'https://www.notion.so/fd5205a3735241ce9737ab55a722f92a',
      SHEET: 'https://www.notion.so/1d8ed978a77241329a2884c83cdae9b7',
      SLIDE: 'https://www.notion.so/4283fd0445a94a34aec8a7be68e363b0',
      WORD: 'https://www.notion.so/Window-Mac-3c5e5cedd6114b4699ee9293a10560d6'
    },
    USER_GUIDE: {
      HWP: 'https://www.notion.so/8eb92ce55de1451f97ac85d53c897b97?v=bde907e88c004db38d7ddd8f1a1d9313',
      SHEET:
        'https://www.notion.so/4961d39154cb4ff28ef0f4e2ce768fd2?v=f6db2654163f4156b6abbba6ff35f452​',
      SLIDE:
        'https://www.notion.so/5c4248b1312b445f9aa784f2d5d0f2fd?v=14cbfc3440c24b0ea922234639ce8aed',
      WORD: 'https://www.notion.so/9307604a1ddc4f41a1bbe381b8aa6236?v=fe6991211e73433da5cf7877d6000972'
    },
    ACTIVELINK_INSERT_GUIDE:
      'https://polarisoffice.notion.site/82e18c8c6af444f5baf0d66bf5f65846?v=ffe9fff8f55544549526f5db0d87701b',
    ACTIVELINK_INSERT_MAP_GUIDE:
      'https://polarisoffice.notion.site/7d11e6fd41d64b228bc5f9276c3d994e',
    ACTIVELINK_INSERT_YOUTUBE_GUIDE:
      'https://polarisoffice.notion.site/URL-fc3dd420dae24604926d5752c41a571a',
    ACTIVELINK_INSERT_EXTERNAL_GUIDE:
      'https://polarisoffice.notion.site/d414aa295bb1448ebf6f8b239c3bc344'
  },
  FEEDBACK: {
    STANDALONE: {
      KO: 'https://docs.google.com/forms/d/e/1FAIpQLScEZ2-uHZ-Pbrey29L8tZ88UkR4TWeh3RHqzbX_p31SyIwfDQ/viewform',
      EN: 'https://docs.google.com/forms/d/e/1FAIpQLSdcj_93vxxQzNGUNITlpMEVGMh6meCDkCMRodqdYQOY3gd-bA/viewform'
    },
    ORG: {
      KO: 'https://forms.gle/3A3kZTQMSTcZY8Ya8'
    },
    EDU: {
      KO: 'https://forms.gle/hjD3pPrwGUU4B8cc8'
    }
  },
  CUSTOMERSUPPORT: {
    KO: {
      HWP: 'https://polarisofficehelp.Zendesk.com/hc/ko/requests/new?product=webhangul&OS=weboffice',
      SHEET:
        'https://polarisofficehelp.zendesk.com/hc/ko/requests/new?product=websheet&OS=weboffice',
      SLIDE:
        'https://polarisofficehelp.zendesk.com/hc/ko/requests/new?product=webslide&OS=weboffice',
      WORD: 'https://polarisofficehelp.zendesk.com/hc/ko/requests/new?product=webword&OS=weboffice'
    },
    EN: {
      HWP: 'https://polarisofficehelp.zendesk.com/hc/en-us/requests/new?OS=weboffice&product=webhangul',
      SHEET:
        'https://polarisofficehelp.zendesk.com/hc/en-us/requests/new?OS=weboffice&product=websheet',
      SLIDE:
        'https://polarisofficehelp.zendesk.com/hc/en-us/requests/new?OS=weboffice&product=webslide',
      WORD: 'https://polarisofficehelp.zendesk.com/hc/en-us/requests/new?OS=weboffice&product=webword'
    }
  },
  TERMS: 'https://polarisoffice.notion.site/Terms-of-Service-8208ab8ced334df486963f414c2cb858',
  PRIVACY: 'https://polarisoffice.notion.site/Privacy-Policy-a39ab61a87ac4c3a86749ac8bd570f9a',
  AD: {
    WEB_OFFICE: 'https://www.polarisoffice.com/weboffice',
    B2B: {
      KO: 'https://www.polarisoffice.com/ko/weboffice?utm_source=poweb&utm_medium=inhousead&utm_campaign=b2bweb',
      EN: 'https://www.polarisoffice.com/en/weboffice?utm_source=poweb&utm_medium=inhousead&utm_campaign=b2bweb'
    }
  }
};

const PO_EDIT_MODE = {
  NONE: 'none',
  READ: 'read',
  EDIT: 'edit',
  PRESENTATION: 'presentation'
};

const DIALOG_TYPE = {
  DIALOG_NONE: 'DIALOG_NONE',
  DIALOG_OPEN_DOCUMENT: 'DIALOG_OPEN_DOCUMENT',
  DIALOG_DOWNLOAD_DOCUMENT: 'DIALOG_DOWNLOAD_DOCUMENT',
  DIALOG_INSTALL_DOCUMENT: 'DIALOG_INSTALL_DOCUMENT',
  DIALOG_SHARE_LINK_DOCUMENT: 'DIALOG_SHARE_LINK_DOCUMENT',
  DIALOG_INVALID_SHARE_LINK: 'DIALOG_INVALID_SHARE_LINK',
  DIALOG_ADD_FAVORITE: 'DIALOG_ADD_FAVORITE',
  DIALOG_FILE_RENAME: 'DIALOG_FILE_RENAME',
  DIALOG_DROPBOX_ERROR: 'DIALOG_DROPBOX_ERROR',
  DIALOG_WHALESPACE_LOGIN: 'DIALOG_WHALESPACE_LOGIN',
  DIALOG_PDF_EXPORT: 'DIALOG_EXPORT_PDF',
  DIALOG_WHALESPACE_USERINFO: 'DIALOG_WHALESPACE_USERINFO',
  DIALOG_UPLOAD_ITT: 'DIALOG_UPLOAD_ITT',
  DIALOG_ACTIVELINK_VOTE: 'DIALOG_ACTIVELINK_VOTE',
  DIALOG_ACTIVELINK_SHAREOPINION: 'DIALOG_ACTIVELINK_SHAREOPINION',
  DIALOG_ACTIVELINK_INSERT_ITT_CONTENTS: 'DIALOG_ACTIVELINK_INSERT_ITT_CONTENTS',
  DIALOG_ACTIVELINK_INSERT_IMAGE_GRID: 'DIALOG_ACTIVELINK_INSERT_IMAGE_GRID',
  DIALOG_ACTIVELINK_YOUTUBE: 'DIALOG_ACTIVELINK_YOUTUBE',
  DIALOG_ACTIVELINK_MAP: 'DIALOG_ACTIVELINK_MAP',
  DIALOG_ACTIVELINK_ANYTHING: 'DIALOG_ACTIVELINK_ANYTHING', // for demo
  DIALOG_ACTIVELINK_CANVAS: 'DIALOG_ACTIVELINK_CANVAS',
  DIALOG_ACTIVELINK_SEATING: 'DIALOG_ACTIVELINK_SEATING',
  DIALOG_TRANSLATE: 'DIALOG_TRANSLATE',
  DIALOG_NAVERWORKS_BROWSER: 'DIALOG_NAVERWORKS_BROWSER',
  DIALOG_UPLOAD_NAVERWORKS_FILE: 'DIALOG_UPLOAD_NAVERWORKS_FILE'
};

const POPUP_PREFIX = 'POPUP_TYPE_';
const POPUP_TYPE = {
  FILEMENU: `${POPUP_PREFIX}FILEMENU`
};

const TRACKING_ID =
  // process.env[`REACT_APP_GA_UA_TRACKING_ID_${selectCurrentFormat()}`] ||
  // process.env.REACT_APP_GA_UA_TRACKING_ID;
process.env[`REACT_APP_GA_GA4_TRACKING_ID_${selectCurrentFormat()}`] ||
process.env.REACT_APP_GA_GA4_TRACKING_ID;

const EDIT_FROM = {
  FROM_HEADER: 'HEADER',
  FROM_FILEMENU: 'FILE_MENU',
  FROM_NOTIFICATION: 'NOTIFICATION',
  FROM_RIBBORN_BANNER: 'RIBBORNBANNER',
  FROM_OPENDIALOG: 'FROM_OPENDIALOG',
  FROM_RIBBORN_MENU: 'RIBBORN_MENU'
};

const BUTTON_UNIKEY = {
  SHARED_LINK_GEN_BTN: 'SHARED_LINK_GEN_BTN',
  SHARED_LINK_COPY_NEW_BTN: 'SHARED_LINK_COPY_NEW_BTN',
  SHARED_LINK_COPY_EXIST_BTN: 'SHARED_LINK_COPY_EXIST_BTN',
  PO_INSTALL_BTN: 'PO_INSTALL_BTN',
  POPUP_AD_CLOSE_BTN: 'POPUP_AD_CLOSE_BTN'
};

const MAC_OS_NAME = 'Mac OS';
const IOS_OS_NAME = 'iOS';
const ANDROID_OS_NAME = 'Android';
const LINUX_OS_NAME = 'Linux'; //maybe samsung tablet internet browser

export const BUCKET_REGION = process.env.REACT_APP_DOC_S3_REGION;
export const BUCKET_NAME = process.env.REACT_APP_DOC_S3_BUCKET;
//export const AWS_S3_POOLID = process.env.REACT_APP_DOC_S3_POOLID;

export const INTERNAL_API_SERVER_ERROR = {
  FILE_TOO_LARGE: 'File too large'
};

export const PRODUCT_TYPE = {
  NONE: 'none',
  STANDALONE: 'standalone',
  WITH_PO_SERVICE: 'withPOService',
  WITH_URL_OPENER_B2B: 'withURLOpenerB2B',
  WITH_GOOGLE_DRIVE: 'withGoogleDrive',
  WITH_DROPBOX: 'withDropbox',
  WITH_WHALE_SPACE: 'withWhaleSpace'
};

export const QS_CONSTANT = {
  PRODUCT_TYPE: {
    KEY: 'productType',
    VALUES: {
      NONE: 'none',
      STANDALONE: 'sa',
      WITH_PO_SERVICE: 'wpos',
      WITH_URL_OPENER_B2B: 'wuob',
      WITH_GOOGLE_DRIVE: 'wgd',
      WITH_DROPBOX: 'wdb',
      WITH_WHALE_SPACE: 'wws'
    }
  },
  START_MODE: {
    KEY: 'startMode',
    VALUES: {
      NEW_DOC: 'newDoc',
      OPEN_MOST_RECENT_DOC: 'openMostRecentDoc',
      SHARE_VIEW: 'shareView',
      OPEN_DOCUMENT_OPENABLE_DIALOG: 'openDocumentOpenableDialog',
      NEW_DOC_FROM_ITT: 'newFromItt',
      OPEN_DOC_FROM_ITT: 'openDocFromItt',
      NEW_DOC_FROM_NAVERWORKS: 'newDocFromNaverworks',
      OPEN_DOC_FROM_NAVERWORKS: 'openDocFromNaverworks',
      VIEW_DOC_FROM_NAVERWORKS: 'viewDocFromNaverworks'
    }
  },
  SU: {
    KEY: 'su'
  },
  SHARE_ID: {
    KEY: 'shareID'
  },
  FILE_ID: {
    KEY: 'fileid'
  },
  ROLE_TYPE: {
    KEY: 'requirerole'
  },
  GOOGLE_DRIVE_FILE_ID: {
    KEY: 'fileid'
  },
  GOOGLE_DRIVE_ACTION_TYPE: {
    KEY: 'action'
  },
  GOOGLE_DRIVE_USER_ID: {
    KEY: 'user'
  },
  EXTENSION_CONNECT_MODE: {
    KEY: 'extConMode'
  },
  ITT_UPLOAD_URL: {
    KEY: 'url'
  },
  ITT_UPLOAD_NTTNO: {
    KEY: 'nttNo'
  }
};

// defined in ua-parser-js d.ts
// console, mobile, tablet, smarttv, wearable, embedded (+ undefined)
const DEVICE_TYPE = {
  CONSOLE: 'console',
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMARTTV: 'smarttv',
  WEARABLE: 'wearable',
  EMBEDDED: 'embedded',
  PC: undefined
};

const DOCUMENT_TYPE = {
  HWP: 'hwp',
  SHEET: 'sheet',
  SLIDE: 'slide',
  WORD: 'word',
  CSV: 'csv'
};

const VIA_PARTNER = {
  ITT: 'itt'
};

const DOC_FORMAT_CONFIG_PREDEFINED = {
  HWP: {
    sdk: {
      documnetType: 'hwp',
      interfaceName: 'hwp'
    },
    extList: ['hwp', 'hwpx'],
    fullExtList: ['.hwp', '.hwpx'],
    defaultExt: '.hwp',
    url: {
      base: URLS.EDITOR.HWP,
      _dev: URLS.EDITOR._HWP_DEV
    },
    name: 'PO_WEB_HWP'
  },
  SHEET: {
    sdk: {
      documnetType: 'sheet',
      interfaceName: 'sheet'
    },
    extList: ['xls', 'xlsx', 'csv'],
    fullExtList: ['.xls', '.xlsx', '.csv'],
    defaultExt: '.xlsx',
    url: {
      base: URLS.EDITOR.SHEET,
      _dev: URLS.EDITOR._SHEET_DEV
    },
    name: 'PO_WEB_SHEET'
  },
  SLIDE: {
    sdk: {
      documnetType: 'slide',
      interfaceName: 'slide'
    },
    extList: ['ppt', 'pptx'],
    fullExtList: ['.ppt', '.pptx'],
    defaultExt: '.pptx',
    url: {
      base: URLS.EDITOR.SLIDE,
      _dev: URLS.EDITOR._SLIDE_DEV
    },
    name: 'PO_WEB_SLIDE'
  },
  WORD: {
    sdk: {
      documnetType: 'word',
      interfaceName: 'word'
    },
    extList: ['doc', 'docx'],
    fullExtList: ['.doc', '.docx'],
    defaultExt: '.docx',
    url: {
      base: URLS.EDITOR.WORD,
      _dev: URLS.EDITOR._WORD_DEV
    },
    name: 'PO_WEB_WORD'
  }
};

let DOC_FORMAT_CONFIG_VALUES =
  DOC_FORMAT_CONFIG_PREDEFINED[
    process.env.REACT_APP_SUPPORT_FORMAT === 'ALL'
      ? selectCurrentFormat()
      : process.env.REACT_APP_SUPPORT_FORMAT
  ];

export const selectFormatAuto = (location) => {
  DOC_FORMAT_CONFIG_VALUES =
    DOC_FORMAT_CONFIG_PREDEFINED[
      process.env.REACT_APP_SUPPORT_FORMAT === 'ALL'
        ? selectCurrentFormat(location)
        : process.env.REACT_APP_SUPPORT_FORMAT
    ];
};

const _BROWSER_STORAGE_BASE_NAME = USE_REACT_ROUTER ? `WEBEDITOR_X_PO_ROUTER` : `WEBEDITOR_X_PO`;
const BROWSER_STORAGE_BASE_NAME = USE_REACT_ROUTER
  ? _BROWSER_STORAGE_BASE_NAME
  : DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.HWP
  ? `${_BROWSER_STORAGE_BASE_NAME}`
  : `${_BROWSER_STORAGE_BASE_NAME}_${DOC_FORMAT_CONFIG_VALUES.sdk.documnetType}`;
const MAX_SHARE_LINK_PERIOD = 14;
const MAX_SHARE_LINK_PERIOD_EDU = 30;
const MAX_SHARE_LINK_COUNT = 3;

const GOOGLE_DYNAMIC_LINK_DOMAIN_URL_PREFIX = 'https://poweb.page.link';

const LANGUAGE = {
  EN: 'en',
  KO: 'ko',
  JA: 'ja',
  ES: 'es'
};

const NOTIFICATION_UPDATE_LIST_COUNT = 5;

export const PRODUCT_TYPE_WHEN_ROUTING = {
  DEV: 'dev',
  WHALE_SPACE: 'whale-space'
};

export const SUPPORT_ROUTINGS = [
  process.env.NODE_ENV === 'development' && {
    producType: PRODUCT_TYPE_WHEN_ROUTING.DEV,
    supportFormats: ['hwp', 'word', 'sheet', 'slide'],
    formatUnderDev: []
  },
  {
    producType: PRODUCT_TYPE_WHEN_ROUTING.WHALE_SPACE,
    supportFormats: ['hwp', 'word', 'sheet', 'slide'],
    formatUnderDev: []
  }
];

export const STARTMODE_WHEN_ROUTING = {
  NEW_DOC: 'new',
  OPEN_MOST_RECENT_DOC: 'openRecent',
  SHARE_VIEW: 'share',
  OPEN_DOCUMENT_OPENABLE_DIALOG: 'openDialog',
 // NEW_DOC_FROM_ITT: 'newFromItt',
 // OPEN_DOC_FROM_ITT: 'openDocFromItt',
 // NEW_DOC_FROM_NAVERWORKS: 'newDocFromNaverworks',
 // OPEN_DOC_FROM_NAVERWORKS: 'openDocFromNaverworks',
 // VIEW_DOC_FROM_NAVERWORKS: 'viewDocFromNaverworks'
};

export const AUTH_STATE = {
  AUTH_INIT: 'init',
  AUTH_NO: 'auth_no',
  AUTH_SUCCESS: 'auth_success',
  AUTH_FAIL: 'auth_fail',
  AUTH_BLOCK_POPUP: 'auth_popup_block'
};

export const AUTH_STATE_KEY = 'authState';

export {
  MAX_OPEN_FILE_SIZE,
  URLS,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_PO,
  PO_EDIT_MODE,
  DIALOG_TYPE,
  POPUP_TYPE,
  BROWSER_STORAGE_BASE_NAME,
  MAX_SHARE_LINK_PERIOD,
  MAX_SHARE_LINK_PERIOD_EDU,
  MAX_SHARE_LINK_COUNT,
  TRACKING_ID,
  EDIT_FROM,
  BUTTON_UNIKEY,
  MAC_OS_NAME,
  IOS_OS_NAME,
  ANDROID_OS_NAME,
  LINUX_OS_NAME,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_MAC,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_IOS,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_ANDROID,
  DEVICE_TYPE,
  DOC_FORMAT_CONFIG_PREDEFINED,
  DOC_FORMAT_CONFIG_VALUES,
  GOOGLE_DYNAMIC_LINK_DOMAIN_URL_PREFIX,
  LANGUAGE,
  DOCUMENT_TYPE,
  VIA_PARTNER,
  NOTIFICATION_UPDATE_LIST_COUNT,
  USE_REACT_ROUTER
};
